/**
 * commentSchema.js
 *
 * Minimal ProseMirror schema for the comment input editor.
 * Supports: doc → paragraph+
 * Inline marks: strong, em, link
 * Inline nodes: userMention (reused from main editor)
 *
 * No block IDs, no classification, no tables — kept intentionally small.
 */

import {Schema} from 'prosemirror-model';
import {userMentionNode} from '../../prosemirror-editor/core/nodes';

export const commentSchema = new Schema({
    nodes: {
        doc: {
            content: 'block+',
        },
        paragraph: {
            group: 'block',
            content: 'inline*',
            parseDOM: [{tag: 'p'}],
            toDOM() {
                return ['p', 0];
            },
        },
        text: {
            group: 'inline',
        },
        userMention: userMentionNode,
        hard_break: {
            inline: true,
            group: 'inline',
            selectable: false,
            parseDOM: [{tag: 'br'}],
            toDOM() {
                return ['br'];
            },
        },
    },
    marks: {
        strong: {
            parseDOM: [
                {tag: 'strong'},
                {tag: 'b', getAttrs: (node) => node.style.fontWeight !== 'normal' && null},
                {style: 'font-weight=bold'},
                {style: 'font-weight=700'},
            ],
            toDOM() {
                return ['strong', 0];
            },
        },
        em: {
            parseDOM: [{tag: 'i'}, {tag: 'em'}, {style: 'font-style=italic'}],
            toDOM() {
                return ['em', 0];
            },
        },
        link: {
            attrs: {
                href: {},
                title: {default: null},
            },
            inclusive: false,
            parseDOM: [
                {
                    tag: 'a[href]',
                    getAttrs(dom) {
                        return {href: dom.getAttribute('href'), title: dom.getAttribute('title')};
                    },
                },
            ],
            toDOM(node) {
                const {href, title} = node.attrs;
                return ['a', {href, title}, 0];
            },
        },
    },
});

